import React from 'react'
import _ from '/home/ps/root'
import './index.css'
import { connect } from 'react-redux'
import View from '../../view'
// import {
//   masterPropType,
//   masterStateToProp,
//   masterDispatchToProp,
// } from '../../../type'
export const ID = 'oob'
export const MasterOutOfBand = prop => {
  const {cookie} = prop.master
  // const onClick = e => {
  //   // e.stopPropagation()
  //   // this.props.action.face({ID: ID})
  // }
  // const p = {id:ID, onClick}
  const p = {id:ID}
  // <div style={{minHeight: '96px'}}>
  return (
    <div {...p}>
      <div>
      </div>
      {/*Out of Band*/}
      <div>debug
      {
        Object.keys(cookie).reduce((acc, id) => {
          acc.push(<div key={id}>{id}: {cookie[id]}</div>)
          return acc
        }, [])
      }
      </div>
    </div>
  )
}
// MasterOutOfBand.propTypes = masterPropType;
// export default connect(
//   masterStateToProp,
//   masterDispatchToProp
// )(MasterOutOfBand)
MasterOutOfBand.ID = ID
export default MasterOutOfBand
